import { useEffect, useState } from "react";
import "./AppCompanyHolidays.css";
import { CompanyHoliday, CompanyHolidayType, DC_COMPONENT_LABELS } from "winslow-core";
import { apiGetCompanyHolidaysForWorkspace } from "../../../services/PaidTimeOffPolicyService";
import { useDispatch, useSelector } from "react-redux";
import { selectUIStates, selectUser, setUIStates } from "../../../redux/features/appData";
import { set } from "lodash";
import DatePicker from "react-datepicker";
import { convertToLocalTimezone, getNthDayOfWeek, getLastWeekdayOfMonth, getNextDay} from "./companyHolidayUtils";
import { AppCompanyHolidaysPreview } from "./AppCompanyHolidaysPreview";
import { Button } from "../../../ds2/components";
import { AppCompanyHolidayNew } from "./AppCompanyHolidayNew";

export type CompanyHolidayPreviewType = {
    name: string;
    thisYear: Date | null;
    nextYear: Date | null;
}

type AppPTOHolidaysProps = {
    showAddingHoliday: boolean;
    onCancel?: () => void;
}

export const AppCompanyHolidays = ({showAddingHoliday, onCancel}: AppPTOHolidaysProps) => {

    const storeUser = useSelector(selectUser);
    const dispatch = useDispatch();
    const uiStates = useSelector(selectUIStates);

    const [addingHoliday, setAddingHoliday] = useState<boolean>(showAddingHoliday);
    const [companyHolidays, setCompanyHolidays] = useState<CompanyHoliday[] | undefined>(undefined);
    const [newCompanyHoliday, setNewCompanyHoliday] = useState<any | undefined>(undefined);

    useEffect(() => {
        dispatch(setUIStates({...uiStates, hrisLocation: "Company Holidays"}));
    }, []);

    useEffect(() => {

        if (!storeUser?.currentWorkspaceId) {
            return;
        }

        // Fetch company holidays from the server
        (async () => {
            const companyHolidays = await apiGetCompanyHolidaysForWorkspace(storeUser.currentWorkspaceId || "");

            console.log("[AppCompanyHolidays] companyHolidays: ", companyHolidays);

            if (companyHolidays) {
                setCompanyHolidays(companyHolidays);
            }

            // if (companyHolidays) {
            //     const holidaysProcessed = companyHolidays.map((holiday) => {
            //         let thisYear: Date | null = null;
            //         let nextYear: Date | null = null;

            //         switch (holiday.type) {
            //             case CompanyHolidayType.DATE:
            //                 if (holiday.date) {
            //                     const useDate = convertToLocalTimezone(holiday.date);
            //                     thisYear = new Date(useDate.getFullYear(), useDate.getMonth(), useDate.getDate());
            //                     nextYear = new Date(useDate.getFullYear() + 1, useDate.getMonth(), useDate.getDate());

            //                     console.log("[AppCompanyHolidays] holiday.date: ", holiday.date);
            //                     console.log("[AppCompanyHolidays] useDate: ", useDate);
            //                     console.log("[AppCompanyHolidays] thisYear: ", thisYear);
            //                     console.log("[AppCompanyHolidays] nextYear: ", nextYear);
            //                 }
            //                 break;
            //             case CompanyHolidayType.NTH:
            //                 if (holiday.nth && holiday.dayOfWeek && holiday.month) {
            //                     thisYear = getNthDayOfWeek(holiday.nth, holiday.dayOfWeek, holiday.month, new Date().getFullYear());
            //                     nextYear = getNthDayOfWeek(holiday.nth, holiday.dayOfWeek, holiday.month, new Date().getFullYear() + 1);
            //                 }
            //                 break;
            //             case CompanyHolidayType.LAST:
            //                 if (holiday.dayOfWeek && holiday.month) {
            //                     thisYear = getLastWeekdayOfMonth(holiday.dayOfWeek, holiday.month, new Date().getFullYear());
            //                     nextYear = getLastWeekdayOfMonth(holiday.dayOfWeek, holiday.month, new Date().getFullYear() + 1);
            //                 }
            //                 break;  
            //             // case CompanyHolidayType.DAY_AFTER:
            //             //     if (holiday.date) {
            //             //         const nextDay = getNextDay(holiday.date);
            //             //         thisYear = new Date(nextDay.getFullYear(), nextDay.getMonth(), nextDay.getDate());
            //             //         nextYear = new Date(nextDay.getFullYear() + 1, nextDay.getMonth(), nextDay.getDate());
            //             //     }
            //         }

            //         return {
            //             name: holiday.name,
            //             thisYear: thisYear,
            //             nextYear: nextYear,
            //         } as CompanyHolidayPreviewType;
            //     })

            //     holidaysProcessed.sort((a, b) => {
            //         if (a.thisYear && b.thisYear) {
            //             return a.thisYear.getTime() - b.thisYear.getTime();
            //         } else if (a.thisYear && !b.thisYear) {
            //             return -1;
            //         } else if (!a.thisYear && b.thisYear) {
            //             return 1;
            //         } else {
            //             return 0;
            //         }
            //     })

            //     setCompanyHolidays(holidaysProcessed);

            // }

        })();
    }, []);

    useEffect(() => {
        setAddingHoliday(showAddingHoliday);
        setNewCompanyHoliday({
            name: "",
            type: CompanyHolidayType.DATE,
            date: new Date(),
            repeats: false,
            dayOfWeek: 0,
            month: 1,
            nth: 1,
        });
    }, [showAddingHoliday]);

    console.log("[AppCompanyHolidays] addingHoliday: ", addingHoliday);
    // const thisYear = new Date().getFullYear();
    // const nextYear = thisYear + 1;

    return (
        <div className="app-company-holidays">
            
            <div className="app-company-holidays-content">

                {/* <div className="app-company-holidays-add">
                    <a 
                        onClick={handleAddHoliday}
                    >
                        Add a custom holiday
                    </a>
                            
                </div> */}
                {addingHoliday &&
                    <AppCompanyHolidayNew 
                        onCancel={onCancel}
                    />
                }
                {!addingHoliday &&
                    <AppCompanyHolidaysPreview
                        companyHolidays={companyHolidays}
                    /> 
                }

                {/* <div className="app-company-holidays-grid">
                    <div className="app-company-holidays-grid-header-item">Holiday</div>
                    <div className="app-company-holidays-grid-header-item">{thisYear}</div>
                    <div className="app-company-holidays-grid-header-item">{nextYear}</div>
                
                    {companyHolidays && companyHolidays.map((holiday, index) => {
                        return (
                            <>
                                <div className="app-company-holidays-grid-item">
                                        {holiday.name}
                                </div>
                                <div className="app-company-holidays-grid-item">
                                  
                                        {holiday.thisYear ? holiday.thisYear.toLocaleDateString() : "N/A"}
                                </div>
                                <div className="app-company-holidays-grid-item">
                                   
                                        {holiday.nextYear ? holiday.nextYear.toLocaleDateString() : "N/A"}
                                </div>
                            </>
                        )}
                    )}
                </div> */}

            </div>
        </div>
    )
}